/**
 * Passe-partout Cart — Atelier Toon
 *
 * 1. Verbergt de variant-select die Meta/Facebook Pixel injecteert.
 * 2. Injecteert een "Bekijk je ontwerp"-link in de Essential cart drawer
 *    voor passe-partout items, op basis van de _Voorbeeld cart-property.
 */
(function () {
  'use strict';

  /* ── 1. Verberg Meta/Facebook Pixel variant-select ───────────── */
  var CSS = 'select[aria-label*="Stel je eigen passe-partout"] { display: none !important; }';
  function injectCSS() {
    if (document.getElementById('ppb-fb-hide')) return;
    var s = document.createElement('style');
    s.id = 'ppb-fb-hide';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  injectCSS();
  new MutationObserver(injectCSS).observe(document.documentElement, { childList: true, subtree: false });

  /* ── 2. "Bekijk je ontwerp"-link in Essential cart drawer ─────── */

  function applyLinks() {
    var drawerItems = document.querySelectorAll('[data-essential-cart-element="cart-drawer-item"]');
    if (!drawerItems.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        items.forEach(function (item, i) {
          var url = item.properties && (item.properties['_Voorbeeld'] || item.properties['_Preview']);
          if (!url) return;

          var drawerItem = drawerItems[i];
          if (!drawerItem) return;

          /* Verberg alleen de variant-selector voor ppb-items (verwijderknop blijft zichtbaar) */
          var variantSel = drawerItem.querySelector('[data-essential-cart-element="line-item-variant-selector"]');
          if (variantSel) variantSel.style.setProperty('display', 'none', 'important');

          /* Niet twee keer injecteren */
          if (drawerItem.querySelector('.ppb-preview-link')) return;

          var link = document.createElement('a');
          link.className = 'ppb-preview-link';
          link.href = url;
          link.target = '_blank';
          link.rel = 'noopener';
          var isEN = document.documentElement.lang.indexOf('en') === 0 || window.location.pathname.indexOf('/en/') === 0;
          link.textContent = isEN ? 'View your design →' : 'Bekijk je ontwerp →';
          link.style.cssText = 'display:block;font-size:0.8em;margin-top:6px;color:inherit;text-decoration:underline;opacity:0.7;';

          /* Voeg in na de properties-lijst */
          var props = drawerItem.querySelector('[data-essential-cart-element="line-item-properties"]');
          if (props) {
            props.insertAdjacentElement('afterend', link);
          } else {
            var details = drawerItem.querySelector('[data-essential-cart-element="cart-drawer-item-details"]');
            if (details) details.appendChild(link);
          }
        });
      })
      .catch(function () {});
  }

  /* Na cart-events */
  ['cart:updated', 'cart:open', 'cart:refresh', 'cart:added', 'on:cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(applyLinks, 200); });
  });

  /* DOM-mutaties — Essential herrendert de drawer */
  var mutationTimer;
  new MutationObserver(function () {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(applyLinks, 150);
  }).observe(document.body, { childList: true, subtree: true });

  /* Eerste keer bij laden */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLinks);
  } else {
    applyLinks();
  }

})();
